import { useSyncExternalStore } from 'react';
import { inputManager } from '../../input/manager';
import type { InputStatus } from '../../input/types';
import { missionsStore, type MissionsState } from '../../store/missions';
import { progressStore, type Progress } from '../../store/progress';
import { settingsStore, type Settings } from '../../store/settings';

export function useSettings(): Settings {
  return useSyncExternalStore(
    (cb) => settingsStore.subscribe(cb),
    () => settingsStore.get(),
    () => settingsStore.get(),
  );
}

export function useProgress(): Progress {
  return useSyncExternalStore(
    (cb) => progressStore.subscribe(cb),
    () => progressStore.get(),
    () => progressStore.get(),
  );
}

export function useMissions(): MissionsState {
  return useSyncExternalStore(
    (cb) => missionsStore.subscribe(cb),
    () => missionsStore.get(),
    () => missionsStore.get(),
  );
}

export function useInputStatus(): InputStatus {
  return useSyncExternalStore(
    (cb) => inputManager.onStatusChange(cb),
    () => inputManager.getStatus(),
    () => inputManager.getStatus(),
  );
}
